module.exports = __webpack_public_path__ + "static/media/Meghan4.dd005ddc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/spoon/Meghan4.jpg
// module id = 134
// module chunks = 0